import dayjs from "dayjs";
import moment from "moment";
import imageCompression from "browser-image-compression";
import { useEffect, useState } from "react";
import { TimeRangePickerProps } from "antd";
import { TimesheetApprovalStatus } from "./Context";
import NoImage from "../Assets/Images/NoImage.jpg";
import BoatPlaceholder from "../Assets/Images/boat-placeholder.png";
import utc from "dayjs/plugin/utc";
import { decryptByText } from "./bycrypt";
import EmployeeNoImage from "../Assets/Images/EmployeeNoimage.png";
import { ItemSVGs } from "../Admin/Pages/Boats/Components/Modals/StoreItemOnMap";
import { useSelector } from "react-redux";
import { RootState, useAppSelector } from "../store";

dayjs.extend(utc);

// import { AxiosErrorResponse, Scope } from "../Enum/utilsEnum";

//** Function to get AWS secret access key */
export const getS3SecretAccessKey = (value: string) => {
  const finalKey = value!.slice(6, 46);
  return finalKey;
};
export const roundDownToTwoDecimals = (num: number): number => {
  return Number(num);
};

export const mathRoundupFunction = (value: any) => {
  return Number(value);
};

export const showTwoDigitValues = (amount: any) => {
  let truncatedValue = Math.floor(amount * 100) / 100;
  return truncatedValue ? truncatedValue?.toFixed(2) : 0.0;
};
//** Function to get Captcha secret key */
export const getCAPTCHASecretKey = (value: string) => {
  const finalKey = value!.slice(12, 52);
  return finalKey;
};

//** Function to get Captcha site key */
export const getCAPTCHASiteKey = (value: string) => {
  const finalKey = value!.slice(18, 58);
  return finalKey;
};

//** Function to get backend API  key */
export const getAPIKey = (value: string) => {
  const finalKey = value!.slice(9, 253);
  return finalKey;
};

/** Environment */
// Set below key and url accroding to your project
// export const API_KEY = import.meta.env.VITE_API_KEY;
// export const API_URL = import.meta.env.VITE_API_URL;

export const DefaultNoImage = NoImage;
export const DefaultEmployeeNoImage = EmployeeNoImage;

export const DefaultBoatImage = BoatPlaceholder;

// For dev server set alias
export let API_URL: string = process.env.REACT_APP_API_URL || "";
export let BACKEND_DOMAIN: string;
export let API_KEY: string = process.env.REACT_APP_API_KEY || "";
export let BUCKET_URL: string;
export let STORE_URL: string;
export let PROFILE_URL: string;
export let STATIC_PAGE_URL: string;
export let USER_SAMPLE_CSV: string;
export let INSERT_BASE_CSV: string;
export let CLIENT_URL = process.env.REACT_APP_CLIENT_URL;
export let Image_URL: any = process.env.REACT_APP_CONTABO_BUCKET_PREFIX_URL;
export let Sample_Csv_Url: any = process.env.REACT_APP_CSV_SAMPLE_BASE_URL;

export const API_VERSION = `v1`;

export let IS_DEV = process.env.REACT_APP_IS_DEV || 0;
export let responseEncrypted = process.env.REACT_APP_IS_ENCRYPTED;
export let secretKey: string = process.env.REACT_APP_ENCRYPT_KEY || "";

export const alias = process.env.REACT_APP_ALIAS;
export const appName = "JohansonBoatworks";
/** User Roles */
export const ROLE = {
  ADMIN: "admin",
  USER: "user",
  SUB_ADMIN: "sub-admin",
  HR: "HR",
  EMPLOYEE: "Employee",
  CUSTOMER: "Customer",
  CREW: "Crew/Worker",
};
export const USER_DEFAULT_PERMISSIONS_ARRAY: any = {
  READ: "read",
  ADD: "add",
  EDIT: "edit",
  DELETE: "delete",
  APPROVE: "approve",
  FOR_ALL_USER: "access_of_all_user",
  CHANGE_STATUS: "change_status",
  ESTIMATE_APPROVE_DECLINE: "estimate_approve_and_decline",
  INVOICE_APPROVE_DECLINE: "invoice_approve_and_decline",
  ACCEPT_PAYMENT: "accept_payment",
};

export const Customer_default_slug = process.env.REACT_APP_CUSTOMER_ROLE_SLUG;

/** Client URL */
// export let CLIENT_URL = IS_DEV ? "http://localhost:3000" + alias : "https://dev.3rddigital.com" + alias;

/** Common Variables */
//  export const EMAIL_REGEX = /^[\w+-.]+@([\w-]+\.)+[\w-]{2,4}$/g;

export const RightsReservedString = "© 2025 Johanson Boatworks. All rights reserved.";

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const PHONE_REGEX =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
export const ONLY_NUMBERS_REGEX = /^[0-9]+$/;
export const ONLY_ALPHABETS_REGEX = /^[A-Za-z ]+$/;
export const allowedExtensions = [
  "pdf",
  "jpeg",
  "jpg",
  "png",
  "gif",
  "bmp",
  "ico",
  "svg",
  "heif",
  "apng",
  "avif",
  "webp",
  "tiff",
];
export const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;

/** Date Functions Starts */
export const dayjsFormat = "MM/DD/YYYY";
export const dayjsFormatTime = "MM/DD/YYYY hh:mm A";
export const lifetimeDate = new Date(dayjs("01-01-2024").format(dayjsFormat));
const day = new Date(dayjs("01-01-2024").format(dayjsFormat)).getDate();
const month = new Date(dayjs("01-01-2024").format(dayjsFormat)).getMonth() + 1;
const year = new Date(dayjs("01-01-2024").format(dayjsFormat)).getFullYear();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const momentDDMMYY = (data: any) => moment(data).format(dayjsFormat);
export const momentYYYYMMMMDDD = (data: any) => moment(data).format("YYYY-MM-DD");
export const momentDateTime = (data: moment.MomentInput) => moment(data).format(dayjsFormatTime);

export const formatHolidayDate = (iso?: string | null) => {
  if (!iso) return "-";

  const [year, month, day] = iso.split("T")[0].split("-");
  return `${month}/${day}/${year}`;
};

export const parseHolidayDate = (from: string | dayjs.Dayjs | null) => {
  if (!from) return null;
  if (typeof from === "string") return dayjs(from.split("T")[0]);
  return from; // already a dayjs object
};


export const formatISOToMMDDYYYY = (iso?: string | null) => {
  if (!iso) return "--";

  const [datePart, timePart] = iso.split("T");

  // DATE-ONLY case (00:00:00.000Z)
  if (!timePart || timePart.startsWith("00:00:00")) {
    const [year, month, day] = datePart.split("-");
    return `${month}/${day}/${year}`;
  }

  // DATETIME case → convert using native Date (local timezone)
  const d = new Date(iso);

  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  const yyyy = d.getFullYear();

  return `${mm}/${dd}/${yyyy}`;
};
export const toDateNumber = (iso: string) => {
  const [y, m, d] = iso.split("T")[0].split("-");
  return Number(`${y}${m}${d}`);
};
export const addDays = (iso: string, days: number) => {
  const [y, m, d] = iso.split("T")[0].split("-").map(Number);
  const date = new Date(Date.UTC(y, m - 1, d + days));
  return Number(
    `${date.getUTCFullYear()}${String(date.getUTCMonth() + 1).padStart(2, "0")}${String(date.getUTCDate()).padStart(2, "0")}`
  );
};

export const momentDDMMYYHHMMAUTC = (data: any) => moment(data).utc().format("YYYY-MM-DD");

export const ageCounterDateFormate = (data: any) => moment(data).format("YYYY-MM-DD");

export function formatTime({ hours, min }: { hours: number; min: number }): string {
  const period = hours >= 12 ? "PM" : "AM";
  const formattedHours = hours % 12 || 12; // Convert to 12-hour format, with 12 instead of 0
  const formattedMinutes = min?.toString()?.padStart(2, "0"); // Ensure 2-digit minutes
  return `${formattedHours}:${formattedMinutes} ${period}`;
}

export const lifetimeDateWithFormat = `${year}-${month < 9 ? `0${month}` : month}-${day < 9 ? `0${day}` : day}`;

// MM/DD/YYYY HH:MMAM/PM
// export const utcToLocalDateWithTime = (utcDate: string): string => {
//   const date = new Date(utcDate);
//   const options: Intl.DateTimeFormatOptions = {
//     day: "2-digit",
//     month: "2-digit",
//     year: "numeric",
//     hour: "2-digit",
//     minute: "2-digit",
//     hour12: true,
//   };

//   const localDateString = date.toLocaleString("en-GB", options);

//   const [datePart, timePart] = localDateString.split(", ");
//   const [day, month, year] = datePart.split("/");
//   const [hourMinute, ampm] = timePart.split(" ");

//   return `${day}/${month}/${year} ${hourMinute}${ampm.toUpperCase()}`;
// };

// export const utcToLocalDate = (utcDate: string): string => {
//   const date = new Date(utcDate);

//   const day = String(date.getDate()).padStart(2, "0");
//   const month = String(date.getMonth() + 1).padStart(2, "0");
//   const year = String(date.getFullYear());

//   return `${day}/${month}/${year}`;
// };
const usDateFormateEnv = process.env.REACT_APP_DATE_FORMATE;
export const usDateFormate = usDateFormateEnv;

export const utcToLocalDateWithTime = (utcDate: string): string => {
  return dayjs.utc(utcDate).local().format(`${usDateFormate} hh:mmA`);
};

export const utcToLocalDate = (utcDate: string): string => {
  return dayjs.utc(utcDate).local().format(`${usDateFormate}`);
};

export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};

export const rightsReserved = "© 2024 SoloAtSea LLC. All rights reserved.";

export const imageCompressorFn = async (file: any, setState: any, setLoader: any) => {
  const options = {
    maxSizeMB: 0.4,
    maxWidthOrHeight: 1920,
    useWebWorker: true,
  };
  try {
    if (setLoader) {
      setLoader(true);
    }
    const compFile = await imageCompression(file, options);
    if (setLoader) {
      setLoader(false);
    }
    setState(compFile);
  } catch (error) {
    setState(file);
  }
};

export function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}

export const disableFutureDates = (current: any) => {
  return current && current > dayjs().endOf("day");
};

export const disablePastDates = (current: any) => {
  return current && current < dayjs().startOf("day");
};

export const PermissionChecker = (roleName: string, PermissionsArray: any, permission: any) => {
  if (roleName == ROLE?.ADMIN) {
    return true;
  } else if (PermissionsArray?.includes(permission)) {
    return true;
  } else {
    return false;
  }
};

export const AccessiblePermission = (roleName: string, PermissionsArray: any) => {
  const { user }: any = useAppSelector((state: RootState) => state.auth);

  const Read_Permission = PermissionChecker(roleName, PermissionsArray, USER_DEFAULT_PERMISSIONS_ARRAY.READ);
  const Add_Permission = PermissionChecker(roleName, PermissionsArray, USER_DEFAULT_PERMISSIONS_ARRAY.ADD);
  const Edit_Permission = PermissionChecker(roleName, PermissionsArray, USER_DEFAULT_PERMISSIONS_ARRAY.EDIT);
  const Delete_Permission = PermissionChecker(roleName, PermissionsArray, USER_DEFAULT_PERMISSIONS_ARRAY.DELETE);
  const Approve_Permission = PermissionChecker(roleName, PermissionsArray, USER_DEFAULT_PERMISSIONS_ARRAY?.APPROVE);
  const ForAllUser = PermissionChecker(roleName, PermissionsArray, USER_DEFAULT_PERMISSIONS_ARRAY?.FOR_ALL_USER);
  const Change_Status = PermissionChecker(roleName, PermissionsArray, USER_DEFAULT_PERMISSIONS_ARRAY?.CHANGE_STATUS);
  const EstimateApproveDeclient = PermissionChecker(
    roleName,
    PermissionsArray,
    USER_DEFAULT_PERMISSIONS_ARRAY?.ESTIMATE_APPROVE_DECLINE
  );
  const InvoiceApproveDeclient = PermissionChecker(
    roleName,
    PermissionsArray,
    USER_DEFAULT_PERMISSIONS_ARRAY?.INVOICE_APPROVE_DECLINE
  );
  const AcceptPay = PermissionChecker(roleName, PermissionsArray, USER_DEFAULT_PERMISSIONS_ARRAY?.ACCEPT_PAYMENT);
  const is_admin = roleName == ROLE?.ADMIN ? true : false;
  const is_customer = user?.is_customer ? true : false;
  return {
    READ: Read_Permission,
    ADD: Add_Permission,
    EDIT: Edit_Permission,
    DELETE: Delete_Permission,
    APPROVE: Approve_Permission,
    FOR_ALL_USER: ForAllUser,
    CHANGE_STATUS: Change_Status,
    ADMIN: is_admin,
    ESTIMATE_APPROVE_DECLINE: EstimateApproveDeclient,
    INVOICE_APPROVE_DECLINE: InvoiceApproveDeclient,
    ACCEPT_PAY: AcceptPay,
    IS_CUSTOMER: is_customer,
  };
};

export const calculateAge = (birthDate: string): { count: number; unit: string } => {
  const birth = new Date(birthDate);
  const today = new Date();
  today.setDate(today.getDate() + 1);
  let years = today.getFullYear() - birth.getFullYear();
  let months = today.getMonth() - birth.getMonth();
  let days = today.getDate() - birth.getDate();

  // Adjust if the birth month has not yet occurred this year
  if (months < 0 || (months === 0 && days < 0)) {
    years--;
    months += 12;
  }

  // Adjust days if the current day is less than the birth day
  if (days < 0) {
    const prevMonth = new Date(today.getFullYear(), today.getMonth(), 0);
    days += prevMonth.getDate();
    months--;
  }

  if (years >= 1) {
    return { count: years, unit: "Year" };
  } else if (months >= 1) {
    return { count: months, unit: "Month" };
  } else {
    return { count: days, unit: "Day" };
  }
};

export const calculateAgeWithString = (birthDate: string): string => {
  const birth = new Date(birthDate);
  const today = new Date();

  let years = today.getFullYear() - birth.getFullYear();
  let months = today.getMonth() - birth.getMonth();

  if (months < 0) {
    years--;
    months += 12;
  }
  return `${years} year${years !== 1 ? "s" : ""} ${months} month${months !== 1 ? "s" : ""}`;
};

export const rangePresets: TimeRangePickerProps["presets"] | undefined = [
  { label: "Last 7 Days", value: [dayjs().add(-7, "d"), dayjs()] },
  { label: "Last 14 Days", value: [dayjs().add(-14, "d"), dayjs()] },
  { label: "Last 30 Days", value: [dayjs().add(-30, "d"), dayjs()] },
  { label: "Last 90 Days", value: [dayjs().add(-90, "d"), dayjs()] },
];

export const BulkStatus = [
  {
    prevStep: TimesheetApprovalStatus?.SUBMIT_APPROVAL,
    value: TimesheetApprovalStatus?.APPROVED,
    key: "Approved",
  },
  {
    prevStep: TimesheetApprovalStatus?.DRAFT,
    value: TimesheetApprovalStatus?.SUBMIT_APPROVAL,
    key: "Submit for Approval",
  },
  {
    prevStep: TimesheetApprovalStatus?.APPROVED,
    value: TimesheetApprovalStatus?.PROCESSED,
    key: "Processed",
  },
];

export const createFormData = (formDataObject: any, files: any = {}): FormData => {
  const formData = new FormData();

  // Helper function to append nested objects
  const appendFormData = (data: any, rootKey: string | null = null) => {
    Object.entries(data).forEach(([key, value]: any) => {
      const formKey: string = rootKey ? `${rootKey}[${key}]` : key;

      if (value instanceof File || value instanceof Blob) {
        // Handle files separately
        formData.append(formKey, value);
      } else if (value && typeof value === "object" && !Array.isArray(value)) {
        // Handle nested objects
        appendFormData(value, formKey);
      } else if (Array.isArray(value)) {
        // Handle arrays
        value.forEach((item, index) => {
          if (typeof item === "object") {
            appendFormData(item, `${formKey}[${index}]`);
          } else {
            formData.append(`${formKey}[${index}]`, item);
          }
        });
      } else {
        // Handle primitive values
        formData.append(formKey, value ?? "");
      }
    });
  };
  if (typeof formDataObject.data == "string") {
    // Append structured data
    appendFormData({ data: formDataObject?.data });
  } else {
    appendFormData(formDataObject);
  }

  // Append files separately
  Object.entries(files).forEach(([key, value]: any) => {
    formData.append(key, value);
  });

  return formData;
};

export const checklistTypeFilterList = [
  { id: 1, label: "Boat Checklist", value: "boat" },
  { id: 2, label: "Non Boat Checklist", value: "non-boat" },
];

export const convertRangeToUTC = (
  dates: any,
  setStartDate: (value: React.SetStateAction<string | null>) => void,
  setEndDate: (value: React.SetStateAction<string | null>) => void
) => {
  const [start, end]: any = dates;
  const currentTime = dayjs();

  const startDateString = dayjs(start)
    .set("hour", currentTime.hour())
    .set("minute", currentTime.minute())
    .set("second", currentTime.second())
    .utc()
    .startOf("day")
    .toISOString();

  const endDateString = dayjs(end)
    .set("hour", currentTime.hour())
    .set("minute", currentTime.minute())
    .set("second", currentTime.second())
    .utc()
    .endOf("day")
    .toISOString();

  setStartDate(startDateString);
  setEndDate(endDateString);
};

export function useDebounceWithReset<T>(value: T, delay: number, resetHandler: () => void): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    if (value === null) return;
    const handler = setTimeout(() => {
      setDebouncedValue(value);
      resetHandler();
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay, resetHandler]);

  return debouncedValue;
}

export enum OperationModes {
  EDIT = "edit",
  DUPLICATE = "duplicate",
}

export enum FillChecklistModes {
  INITIAL = "initial",
  SUBSEQUENT = "subsequent",
}

export enum ChecklistTypes {
  BOAT = "boat",
  NON_BOAT = "non-boat",
}

export enum FormModes {
  ADD = "add",
  EDIT = "edit",
}

export enum Permissions {
  CONDITION_REPORTS = "Condition Reports",
  ISSUES = "Issues",
  YARD = "Yard",
  BOAT = "Boat",
  ESTIMATE = "Estimate",
}

export const getCompleteImageUrl = (path: string): string => {
  if (!path) return "";

  let baseUrl: string;

  const hostname: string = window.location.hostname;

  if (hostname.includes("localhost")) {
    baseUrl = "http://localhost:3030";
  } else if (hostname.includes("dev")) {
    baseUrl = "https://dev.3rddigital.com/johanson-boatworks-api";
  } else {
    baseUrl = "https://johansonboatworks.com";
  }

  return `${baseUrl}/${path.replace(/^\/+/, "")}`;
};

export const getValueOrFallback = (
  value?: string | null,
  shouldDecrypt: boolean = false,
  fallback: string = "-"
): string => {
  if (!value) return fallback;
  return shouldDecrypt ? decryptByText(value) : value;
};

export enum TranslationFiles {
  ISSUES = "issues",
}

export enum IssuesPriorityTypes {
  URGENT = "urgent",
  NON_URGENT = "non-urgent",
}

export enum IssuesStatusTypes {
  OPEN = "open",
  IN_PROGRESS = "in-progress",
  RESOLVED = "resolved",
}

export const capitalizeFirstLetter = (word: string): string => {
  if (!word) return "";
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
};

type SorterState = {
  field: string | null;
  order: "ascend" | "descend" | null;
};

export const formatSorter = (sorterState: SorterState): string => {
  if (!sorterState?.field || !sorterState?.order) return "";
  const order = sorterState.order === "ascend" ? "asc" : "desc";
  return `${sorterState.field} | ${order}`;
};

export const getItemSvg = (item: ItemSVGs, size: number, rotation: number) => {
  switch (item) {
    case ItemSVGs.MAST:
      return `data:image/svg+xml,${encodeURIComponent(
        `<svg width="${size}" height="${size}" viewBox="0 0 60 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g transform="rotate(${rotation}, 30, 5)">
        <path d="M0 3.2L60 0V10L0 6.4V3.2Z" fill="#CD9E13"/>
      </g>
    </svg>`
      )}`;

    case ItemSVGs.EQUIPMENT:
      return `data:image/svg+xml,${encodeURIComponent(
        `<svg width="${size}" height="${size}" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g transform="rotate(${rotation}, 27, 27)">
        <g clip-path="url(#clip0)">
          <path d="M47.7869 0.00563196C47.9569 0.0220895 48.1187 0.0865153 48.2535 0.191404C48.3883 0.296293 48.4906 0.437326 48.5483 0.598076C48.6061 0.758825 48.6169 0.932672 48.5797 1.09936C48.5424 1.26606 48.4586 1.41873 48.3379 1.53961L42.2938 7.57348V9.53261L44.4672 11.7026H46.4196L52.4636 5.66536C52.59 5.54212 52.7498 5.4587 52.9231 5.42545C53.0965 5.39221 53.2758 5.41059 53.4388 5.47833C53.6018 5.54606 53.7413 5.66017 53.8401 5.80649C53.9388 5.9528 53.9924 6.12489 53.9942 6.3014V13.5087C53.9926 13.7446 53.8986 13.9706 53.7323 14.1379L49.2324 18.6378C49.0634 18.8058 48.8347 18.8999 48.5964 18.8997H41.7734L34.0457 26.624L27.3724 19.9541L35.0967 12.2264V5.40006C35.0983 5.16245 35.1937 4.93509 35.362 4.76742L39.8585 0.264129C40.0289 0.096595 40.259 0.00361369 40.4979 0.00563196H47.7018C47.7313 0.00418501 47.7574 0.00418501 47.7869 0.00563196ZM3.70292 0.00563196C3.80952 0.0182536 3.9131 0.0493287 4.00904 0.0974665L13.002 4.59736C13.152 4.67197 13.2783 4.78692 13.3666 4.92932C13.4549 5.07171 13.5018 5.2359 13.502 5.40346V8.63467L33.8246 28.9505L28.954 33.8279L8.63137 13.5053H5.40016C5.06003 13.5053 4.75051 13.308 4.59746 13.0053L0.0941636 4.00553C0.0104222 3.83656 -0.0182095 3.64558 0.0122988 3.45948C0.0428071 3.27338 0.130922 3.10154 0.264231 2.96815L2.96484 0.264129C3.06056 0.168376 3.17661 0.0954153 3.30439 0.050664C3.43216 0.00591273 3.56838 -0.00947904 3.70292 0.00563196ZM19.9474 27.3723L26.6241 34.0524L18.9032 41.7733V48.6031C18.9024 48.7216 18.8783 48.8387 18.8322 48.9479C18.7861 49.057 18.7189 49.156 18.6345 49.2391L14.138 53.739C13.9695 53.9082 13.7408 54.0036 13.502 54.0043H6.2981C6.12009 54.0031 5.94641 53.9493 5.79898 53.8495C5.65154 53.7498 5.53694 53.6086 5.46964 53.4438C5.40234 53.279 5.38534 53.0979 5.4208 52.9235C5.45625 52.749 5.54257 52.589 5.66886 52.4635L11.6993 46.4297V44.4773L9.52931 42.3005H7.57357L1.53631 48.3378C1.40989 48.4624 1.2495 48.5468 1.07526 48.5806C0.901024 48.6144 0.720688 48.596 0.556866 48.5277C0.393044 48.4594 0.25303 48.3443 0.15438 48.1968C0.0557301 48.0492 0.00284007 47.8758 0.00233414 47.6983V40.5046C0.0030252 40.2659 0.0984379 40.0371 0.267631 39.8686L4.76412 35.3619C4.93457 35.1944 5.16457 35.1014 5.40356 35.1034H12.2231L19.9474 27.3723ZM36.9062 28.794C37.1414 28.7974 37.366 28.8926 37.532 29.0593L39.5966 31.1273L31.1274 39.5965L29.0628 37.5319C28.8956 37.3631 28.8018 37.1352 28.8018 36.8976C28.8018 36.66 28.8956 36.432 29.0628 36.2633L36.26 29.0593C36.345 28.9739 36.4463 28.9064 36.5579 28.8609C36.6695 28.8153 36.7857 28.7926 36.9062 28.794ZM40.8687 32.3994L52.0827 43.61C54.5248 46.0521 54.6677 49.95 52.3106 52.3071C49.9535 54.6642 46.0522 54.5179 43.6135 52.0792L32.4029 40.8686L40.8687 32.3994Z" fill="#CD9E13"/>
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="54" height="54" fill="white" transform="matrix(-1 0 0 1 54 0)"/>
          </clipPath>
        </defs>
      </g>
    </svg>`
      )}`;

    case ItemSVGs.DINGHY:
      return `data:image/svg+xml,${encodeURIComponent(
        `<svg width="${size}" height="${size}" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g transform="rotate(${rotation}, 27, 27)">
        <path d="M38.8163 3.16754C38.2612 2.2046 37.4622 1.40486 36.4998 0.848801C35.5373 0.292746 34.4454 -8.09864e-06 33.3339 1.68031e-10L19.752 1.68031e-10C18.9184 -2.13668e-07 18.0994 0.219571 17.3776 0.636618C16.6558 1.05366 16.0566 1.65347 15.6403 2.37568L10.4435 11.3899C9.88937 12.351 9.59767 13.441 9.59766 14.5505L9.59766 50.8359C9.59766 52.5835 11.0142 54 12.7617 54C14.5092 54 15.9258 52.5835 15.9258 50.8359V15.1961C15.9258 14.9412 15.9874 14.6901 16.1053 14.4642L19.9079 7.1782C20.0416 6.92187 20.2431 6.7071 20.4904 6.55723C20.7376 6.40736 21.0212 6.32812 21.3104 6.32812H32.6895C32.9787 6.32812 33.2623 6.40736 33.5095 6.55723C33.7568 6.7071 33.9583 6.92187 34.092 7.1782L37.8946 14.4642C38.0125 14.6902 38.0741 14.9413 38.0741 15.1961V50.8359C38.0741 52.5835 39.4907 54 41.2382 54C42.9857 54 44.4022 52.5835 44.4022 50.8359V14.5505C44.4022 13.441 44.1105 12.351 43.5564 11.3899L38.8163 3.16754Z" fill="#CD9E13"/>
        <path d="M19.0898 44.0859H34.9102V49.5703H19.0898V44.0859ZM19.0898 26.7891H34.9102V32.2734H19.0898V26.7891ZM19.0898 18.1406H34.9102V23.625H19.0898V18.1406ZM19.0898 35.4375H34.9102V40.9219H19.0898V35.4375ZM22.2693 9.49219L19.407 14.9766H34.593L31.7307 9.49219H22.2693Z" fill="#CD9E13"/>
      </g>
    </svg>`
      )}`;
  }
};

export const getBoatSvg = (size: number, rotation: number, color: string, isEditing: boolean = false) => {
  const dottedBorderMovement = isEditing
    ? `<style>
        @keyframes dottedMovement {
          0% {
            stroke-dashoffset: 0;
          }
          100% {
            stroke-dashoffset: 1000;
          }
        }
        .dotted-border {
          stroke: red;
          stroke-width: 2;
          stroke-dasharray: 5, 5;
          animation: dottedMovement 30s linear infinite;  /* Increased duration to 10s */
        }
      </style>`
    : "";

  return `data:image/svg+xml,${encodeURIComponent(
    `<svg width="${size}" height="${size}" viewBox="0 0 14 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      ${dottedBorderMovement}
      <g transform="rotate(${rotation}, 7.19459, 20.0138)">
        <ellipse cx="7.19459" cy="20.0138" rx="19.4523" ry="5.98533" fill="${color}" 
                 class="${isEditing ? "dotted-border" : ""}" />
      </g>
    </svg>`
  )}`;
};

export const boatStorageTypes = [
  {
    label: "Inside",
    value: "Inside",
  },
  {
    label: "Outside",
    value: "Outside",
  },
];

export const boatStorageModes = [
  {
    label: "Heated",
    value: "Heated",
  },
  {
    label: "Unheated",
    value: "Unheated",
  },
];

export const navigateToGoogleMaps = (lat: number, lng: number) => {
  const googleMapsUrl = `https://www.google.com/maps?q=${lat},${lng}&z=18`;
  window.open(googleMapsUrl, "_blank");
};

// export const LOAUnits = ["Feet", "Meters", "Yards", "Inches", "Centimeters", "Millimeters", "Nautical Miles"];
export const LOAUnits = ["Feet", "Meters"];

// export const BEAMUnits = ["Feet", "Meters", "Inches", "Centimeters", "Millimeters", "Yards"];
export const BEAMUnits = ["Feet", "Meters"];

export const DISPLACEMENTUnits = ["Pounds", "Kilograms", "Tons (US)", "Tons (Metric)"];

export const cleanObject = (obj: any): any => {
  if (obj && typeof obj === "object" && !Array.isArray(obj)) {
    return Object.entries(obj).reduce(
      (acc, [key, value]) => {
        if (value && typeof value === "object") {
          const cleaned = cleanObject(value);
          if (Object.keys(cleaned).length > 0) acc[key] = cleaned;
        } else if (value !== null && value !== undefined && value !== "") {
          acc[key] = value;
        }
        return acc;
      },
      {} as Record<string, any>
    );
  }
  return obj;
};

export function getActiveFilterCount(filters: Record<string, any>, keys: string[]): number {
  return keys.reduce((count, key) => {
    const value = filters[key];

    if (value === undefined || value === null || value === "") {
      return count;
    }

    if (Array.isArray(value)) {
      return count + (value.length > 0 ? 1 : 0);
    }

    return count + 1;
  }, 0);
}

export function roundUpToTwoDecimalsForLead(value: number): number {
  const factor = Math.pow(10, 2);
  return Math.round(value * factor) / factor;
}

export function convertFeetToMeters(feet: number): number {
  return roundUpToTwoDecimalsForLead(feet * 0.3048);
}

export function convertMetersToFeet(meters: number): number {
  return roundUpToTwoDecimalsForLead(meters * 3.28084);
}

export const scrollToFirstError = () => {
  setTimeout(() => {
    const errorElement = document.querySelector(".text-danger");

    if (errorElement) {
      errorElement.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, 100);
};
